export const PAQUETE_HOME_LOADING = 'PAQUETE_HOME_LOADING';
export const PAQUETE_HOME_LOADED = 'PAQUETE_HOME_LOADED';
export const PAQUETE_HOME_ERROR = 'PAQUETE_HOME_ERROR';

export const PAQUETEGENERAL_LOADING = 'PAQUETEGENERAL_LOADING';
export const PAQUETEGENERAL_LOADED = 'PAQUETEGENERAL_LOADED';
export const PAQUETEGENERAL_ERROR = 'PAQUETEGENERAL_ERROR';

export const PAQUETEINDI_LOADING = 'PAQUETEINDI_LOADING';
export const PAQUETEINDI_LOADED = 'PAQUETEINDI_LOADED';
export const PAQUETEINDI_ERROR = 'PAQUETEINDI_ERROR';

export const PAQUETE_INDIVIDUAL_LOADING = 'PAQUETE_INDIVIDUAL_LOADING';
export const PAQUETE_INDIVIDUAL_LOADED = 'PAQUETE_INDIVIDUAL_LOADED';
export const PAQUETE_INDIVIDUAL_ERROR = 'PAQUETE_INDIVIDUAL_ERROR';

export const PAQUETEINDI2_LOADING = 'PAQUETEINDI2_LOADING';
export const PAQUETEINDI2_LOADED = 'PAQUETEINDI2_LOADED';
export const PAQUETEINDI2_ERROR = 'PAQUETEINDI2_ERROR';

export const PAQUETE_LOADING = 'PAQUETE_LOADING';
export const PAQUETE_LOADED = 'PAQUETE_LOADED';
export const PAQUETE_ERROR = 'PAQUETE_ERROR';

export const CREARPAQUETE_ERROR = 'CREARPAQUETE_ERROR';
export const CREARPAQUETE_LOADED = 'CREARPAQUETE_LOADED';
export const CREARPAQUETE_LOADING = 'CREARPAQUETE_LOADING';

export const EDITARPAQUETE_ERROR = 'EDITARPAQUETE_ERROR';
export const EDITARPAQUETE_LOADED = 'EDITARPAQUETE_LOADED';
export const EDITARPAQUETE_LOADING = 'EDITARPAQUETE_LOADING';

export const DELETEPAQUETE_ERROR = 'DELETEPAQUETE_ERROR';
export const DELETEPAQUETE_LOADED = 'DELETEPAQUETE_LOADED';
export const DELETEPAQUETE_LOADING = 'DELETEPAQUETE_LOADING';

export const ESPECIE_PAQUETE_ERROR = 'ESPECIE_PAQUETE_ERROR';
export const ESPECIE_PAQUETE_LOADED = 'ESPECIE_PAQUETE_LOADED';
export const ESPECIE_PAQUETE_LOADING = 'ESPECIE_PAQUETE_LOADING';

export const VERSION_PAQUETE_ERROR = 'VERSION_PAQUETE_ERROR';
export const VERSION_PAQUETE_LOADED = 'VERSION_PAQUETE_LOADED';
export const VERSION_PAQUETE_LOADING = 'VERSION_PAQUETE_LOADING';

export const COLABORADOR_PAQUETE_ERROR = 'COLABORADOR_PAQUETE_ERROR';
export const COLABORADOR_PAQUETE_LOADED = 'COLABORADOR_PAQUETE_LOADED';
export const COLABORADOR_PAQUETE_LOADING = 'COLABORADOR_PAQUETE_LOADING';

export const COMPRADOR_PAQUETE_ERROR = 'COMPRADOR_PAQUETE_ERROR';
export const COMPRADOR_PAQUETE_LOADED = 'COMPRADOR_PAQUETE_LOADED';
export const COMPRADOR_PAQUETE_LOADING = 'COMPRADOR_PAQUETE_LOADING';

export const CREAR_VERSION_PAQUETE_ERROR = 'CREAR_VERSION_PAQUETE_ERROR';
export const CREAR_VERSION_PAQUETE_LOADED = 'CREAR_VERSION_PAQUETE_LOADED';
export const CREAR_VERSION_PAQUETE_LOADING = 'CREAR_VERSION_PAQUETE_LOADING';

export const VALORACION_LOADING = 'VALORACION_LOADING';
export const VALORACION_LOADED = 'VALORACION_LOADED';
export const VALORACION_ERROR = 'VALORACION_ERROR';
export const VALORACION_PAQUETE_LIKE = 'VALORACION_PAQUETE_LIKE';
export const VALORACION_PAQUETE_INDIVIDUAL_LIKE = 'VALORACION_PAQUETE_INDIVIDUAL_LIKE';
export const REVERTIR_VALORACION_LIKE = 'REVERTIR_VALORACION_LIKE';